import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import ProjectCard from './ProjectCard';
import { SectionHeading } from './LatestProjects';

const TrendingProjects = () => {
  const { t, projects } = useApp();
  const [cat, setCat] = useState('all');
  const tabs = [
    { key: 'all', label: t('nav_projects') },
    { key: 'villas', label: t('villas') },
    { key: 'luxury', label: t('luxury') },
    { key: 'flats', label: t('flats') },
  ];
  const trendingProjects = projects.filter((p) => p.trending);
  const source = trendingProjects.length >= 4 ? trendingProjects : projects;
  const list = cat === 'all' ? source : projects.filter((p) => p.category === cat);

  return (
    <section className="bg-gobra-sand/60 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <SectionHeading title={t('trending_projects')} />
        <div className="flex flex-wrap gap-2 mb-8">
          {tabs.map((tb) => (
            <button key={tb.key} onClick={() => setCat(tb.key)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${cat === tb.key ? 'bg-gobra-terracotta text-white' : 'bg-white text-gobra-slate border border-gobra-sand hover:border-gobra-terracotta'}`}>
              {tb.label}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {list.slice(0, 8).map((p) => <ProjectCard key={p.id} project={p} />)}
        </div>
        <div className="mt-10 flex justify-center">
          <Link to="/projects" className="inline-flex items-center gap-2 bg-gobra-green hover:bg-gobra-green-dark text-white px-7 py-3 rounded-full text-sm font-medium transition-colors">
            {t('view_all_projects')} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TrendingProjects;
